import { parsePhoneNumberFromString } from 'libphonenumber-js';

/** Common free / personal email domains — work email should not use these. */
const PERSONAL_EMAIL_DOMAINS = new Set([
  'gmail.com',
  'googlemail.com',
  'yahoo.com',
  'yahoo.co.uk',
  'yahoo.co.in',
  'hotmail.com',
  'outlook.com',
  'live.com',
  'msn.com',
  'aol.com',
  'icloud.com',
  'me.com',
  'mac.com',
  'protonmail.com',
  'proton.me',
  'pm.me',
  'mail.com',
  'gmx.com',
  'gmx.net',
  'yandex.com',
  'ymail.com',
  'inbox.com',
  'fastmail.com',
  'tutanota.com',
  'qq.com',
  '163.com',
  '126.com',
  'rediffmail.com',
]);

const EMAIL_FORMAT = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

export function getWorkEmailError(email: string): string | null {
  const trimmed = email.trim().toLowerCase();

  if (!trimmed) {
    return 'Work email is required.';
  }

  if (!EMAIL_FORMAT.test(trimmed)) {
    return 'Enter a valid email address.';
  }

  const domain = trimmed.split('@')[1];

  if (PERSONAL_EMAIL_DOMAINS.has(domain)) {
    return 'Please use your work email address, not a personal email.';
  }

  return null;
}

export function getPhoneError(phone: string): string | null {
  const trimmed = phone.trim();

  if (!trimmed) {
    return 'Phone number is required.';
  }

  if (/[a-zA-Z]/.test(trimmed)) {
    return 'Phone number can only contain digits.';
  }

  const parsed = parsePhoneNumberFromString(trimmed);

  if (!parsed || !parsed.isValid()) {
    return 'Enter a valid phone number.';
  }

  if (!/^\d{10}$/.test(parsed.nationalNumber)) {
    return 'Phone number must be exactly 10 digits.';
  }

  return null;
}

/** Format as E.164 (+1XXXXXXXXXX) for storage. */
export function formatPhoneForSubmit(phone: string): string {
  const trimmed = phone.trim();
  if (!trimmed) return '';

  const parsed = parsePhoneNumberFromString(trimmed);
  return parsed?.format('E.164') ?? trimmed;
}
